<template>
  <div class="cuenta-item" :style="{ marginLeft: depth * 20 + 'px' }">
    <div class="row">
      <div class="col">{{ cuenta.codigo }} - {{ cuenta.nombre }}</div>

      <div class="col text-right">
        <span v-if="cuenta.saldo_anterior">
          {{ cuenta.saldo_anterior | convertPesoArg }}
        </span>
      </div>

      <div class="col text-right">
        <span v-if="cuenta.saldo_mes">
          {{ cuenta.saldo_mes | convertPesoArg }}
        </span>
      </div>

      <div class="col text-right">
        <span v-if="cuenta.saldo_total">
          {{ cuenta.saldo_total | convertPesoArg }}
        </span>
      </div>
    </div>

    <div class="mt-2" v-if="cuenta.subcuentas && cuenta.subcuentas.length > 0">
      <CuentaContableItem
        v-for="sub in cuenta.subcuentas"
        :key="sub.id"
        :cuenta="sub"
        :depth="depth + 1"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "CuentaContableItem",
  props: {
    cuenta: { type: Object, required: true },
    depth: { type: Number, default: 0 },
  },
  
};
</script>

<style scoped>
.cuenta-item {
  padding: 4px 0;
}
.row {
  display: flex;
  border-bottom: 1px solid #ddd;
  padding: 4px 0;
}
.col {
  flex: 1;
}
</style>
